import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CartContextProvider } from "./context/CartContext";
import { AlertContextProvider } from "./context/alertContext";

ReactDOM.render(
  <React.StrictMode>
    <AlertContextProvider>
      <CartContextProvider>
        <App />
      </CartContextProvider>
    </AlertContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
